import { fetchFindings, saveFinding, fetchFindingsProperties, fetchFindingsPropertiesCount, fetchFindingsPropertiesCountByKind } from './findings.api.js';
import { assets, searchAssets } from '../asset/assets.state.svelte.js';
import { vulnerabilities, searchVulnerabilities } from '../vulnerability/vulnerabilities.state.svelte.js';
import { notificate } from '../../services/notification.js';
import { get as getStore } from 'svelte/store';
import tagService from "../tag/service.js";
import { locale, format } from 'svelte-i18n';
import API from '../../services/api.svelte.js';

/* Declare findings data here to avoid a VSO annoying highlight */

const findingsData = $state([]);
//const allFindingsData = $state([]);
const findingsListData = $state([]);


/* Findings state structure */

export const findings = $state({
    data: findingsData,
    // allData: {
    //     updatedAt: null,
    //     data: allFindingsData,
    //     loading: false,
    //     errors: null
    // },
    list: {
        data: findingsListData,
        loading: false,
        errors: null
    },
    loading: false,
    errors: null
});

/*
    START STATE ABM FUNCTIONS
*/

const updateFindings = (updatedFindings = []) => {
    if (!updatedFindings.length) return;

    const index = new Map(
        findingsData.map((f, i) => [f.id, i])
    );

    for (const updated of updatedFindings) {
        const idx = index.get(updated.id);

        if (idx !== undefined) {
            findingsData[idx] = {
                ...findingsData[idx],
                ...updated
            };
        } else {
            findingsData.push(updated);
        }
    }
};

const updateFindingsList = (updatedFindings = []) => {
    if (!updatedFindings.length) return;

    const index = new Map(
        findings.list.data.map((a, i) => [a.id, i])
    );

    for (const updated of updatedFindings) {
        const idx = index.get(updated.id);

        if (idx !== undefined) {
            findings.list.data[idx] = {
                ...findings.list.data[idx],
                ...updated
            };
        }
        else {
            findings.list.data.push(updated);
        }
    }
};


// const updateAllFindingsData = (updatedFindings = []) => {
//     const index = new Map(
//         allFindingsData.map(finding => [finding.id, finding])
//     );

//     for (const updated of updatedFindings) {
//         const existing = index.get(updated.id);
//         if (existing) {
//             Object.assign(existing, updated);
//         } else {
//             allFindingsData.push(updated);
//         }
//     }
// };


/*
    Orchestration logic
*/
let searchFindingsController;

export const cancelFindingSearch = () => {
    searchFindingsController?.abort();
};

export const searchFindings = async (
    resource = 'v2/finding/',
    config = { filter: {}, buildList: {} }
) => {
    if(!config.ignore_loader) findings.loading = true;
    if(!config.ignore_loader) findings.errors = null;
    // Abort previous request if exists
    searchFindingsController?.abort();

    // Create local controller for this search
    const controller = new AbortController();
    searchFindingsController = controller;

    // check if this request is still the latest
    const isCurrent = () => searchFindingsController === controller;

    let response;

    try {
        // Pass controller signal to fetch
        response = await fetchFindings(resource, { ...config, signal: controller.signal });

        if (!isCurrent()) return; // discard if a newer search started

    } catch (err) {
        if (err.name === 'AbortError') {
            if (isCurrent()) searchFindingsController = null; // cleanup
            return []; // silently cancel
        }

        if (!isCurrent()) return;

        replaceFindings([]);
        findings.errors = err;
        return [];
    } finally {
        if (!isCurrent()) return;

        findings.loading = false;

        replaceFindings(response);
        replaceFindingsListElements(findings.data);

        if (config.buildList) {
            findings.list.loading = true;

            response = await hydrateFindingsWithAssetsAndVuls(response, { ...config, signal: controller.signal });
            if (!isCurrent()) return;

            response = await hydrateFindingsWithTags(response, config.buildList.tags.elements, config.buildList.tags.associations, controller.signal);
            if (!isCurrent()) return;

            replaceFindingsListElements(response);
            findings.list.loading = false;
            findings.list.loaded = true;
            // Cleanup global controller if still current
            if (isCurrent()) searchFindingsController = null;

            return findings.list.data;
        }

        // Cleanup global controller if still current
        if (isCurrent()) searchFindingsController = null;
        return findings.data;
    }
};


export async function getFindingDetail(resource, id, config = {}) {
    let finding;
    return findFinding('v2/' + resource, id, config)
        .catch(() => {
            return false;
        })
        .then(pFinding => {
            finding = pFinding;
            return finding;
        })
    ;
}
export const handleFindingsUpsert = async (findingsToBeSaved) => {
    findings.loading = true;

    const updatedFindings = [];
    const errors = [];

    for (const finding of findingsToBeSaved) {
        //table returns everything as a string, hence selected_rows has an incorrect value
        //@TODO: may be salvable
        if(finding.scan_task_id === "") finding.scan_task_id = null;

        try {
            const response = await saveFinding(finding, {}, false);

            if (!response.ok) {
                notificate('save_error', 'toast', {
                    data: getStore(format)('finding.word'),
                    options: {
                        timeOut: "0",
                        extendedTimeOut: "0",
                        closeButton: true
                    }
                });

                throw await response.json();
            }
            else {
                notificate('save_ok', 'toast', {
                    data: getStore(format)('finding.word'),
                    is_massive: false
                });
                let saved = await response.json();
                updatedFindings.push(saved);
            }

        } catch (err) {
            if (typeof err?.detail === 'string') {
                errors.push(API.translateErrorMessages(err.detail, "elements_massive"));
            } else {
                errors.push(API.flatten422Errors(err));
            }
        }
    }

    updateFindings(updatedFindings);
    updateFindingsList(updatedFindings);
    //updateAllFindingsData(updatedFindings);

    findings.loading = false;
    return updatedFindings;
};
export const hydrateFindingsWithAssetsAndVuls = async (data, config) => {
    const signal = config.signal;

    if (signal?.aborted) return data ?? [];

    let vulsConfig = { filter: {} };
    let assetsConfig = { filter: {}, buildList: { properties: true } };
    let vuls_ids = [];

    for (let fnd of data) {
        if (signal?.aborted) return data ? data : [];

        if (vuls_ids.length < 101 && !vuls_ids.includes(fnd.vulnerability_id)) {
            vuls_ids.push(fnd.vulnerability_id);
        } else if (vuls_ids.length >= 101) {
            vuls_ids = null;
            break;
        }
    }

    if (vuls_ids) vulsConfig.filter.id__in = vuls_ids;

    if (config.filter?.vulnerability__level__in) {
        assetsConfig.filter.vulnerability__level__in = config.filter?.vulnerability__level__in;
        if(!vuls_ids) vulsConfig.filter.vulnerability__level__in = config.filter?.vulnerability__level__in;
    }

    await searchVulnerabilities('v2/vulnerability/', { ...vulsConfig, signal });

    if (signal?.aborted) return data ?? [];

    assetsConfig.filter.include_finding_count = false;

    await searchAssets("v2/asset/", { ...assetsConfig, signal });

    if (signal?.aborted) return data ?? [];

    const assetsById = new Map();
    for (const asset of assets.data) {
        assetsById.set(asset.id, asset);
    }

    const vulnsById = new Map();
    for (const vulns of vulnerabilities.data) {
        vulnsById.set(vulns.id, vulns);
    }

    let readLocale = getStore(locale);

    for (let fnd of data) {
        if (signal?.aborted) return data ?? [];

        fnd.asset = assetsById.get(fnd.asset_id);
        let vulnerability = vulnsById.get(fnd.vulnerability_id);

        fnd.vulnerability = readLocale == "es" ? vulnerability.title_es : vulnerability.title;

        fnd.title = vulnerability.title || vulnerability.title_es;
        fnd.priority = vulnerability.priority;
        fnd.level = vulnerability.level;
        fnd.vul_kind = vulnerability.id.split("-")[0];
    }

    return data ?? [];
};

export const hydrateFindingsWithTags = async (data, elements, tagAssociations, signal) => {
    if (signal?.aborted) return data ?? [];

    let tags = [];
    let associations = [];

    const getTags = async (config = { filter: {} }) => {
        if (signal?.aborted) return [];
        return await tagService.search('v2/tag/', config);
    };

    const getTagAssociations = async (config = { filter: { target_object_type: "Finding" } }) => {
        if (signal?.aborted) return [];
        return await tagService.search('v2/tag/association/', config);
    };

    if (!elements || elements.length < 1) {
        tags = await getTags();
        if (signal?.aborted) return data; // stop immediately if cancelled
    } else {
        tags = elements;
    }

    if (!tagAssociations || tagAssociations.length < 1) {
        associations = await getTagAssociations();
        if (signal?.aborted) return data; // stop immediately if cancelled
    } else {
        associations = tagAssociations;
    }

    const tagById = new Map();
    for (const tag of tags) {
        tagById.set(tag.id, tag);
    }

    // Index associations by finding id and store all tag ids
    const associationsByTarget = new Map();
    for (const association of associations) {
        if (!associationsByTarget.has(association.target_object_id)) {
            associationsByTarget.set(association.target_object_id, []);
        }
        associationsByTarget.get(association.target_object_id).push(association.tag_id);
    }

    // hydrate findings with tags
    for (const fnd of data) {
        if (signal?.aborted) return data;

        const tagIds = associationsByTarget.get(fnd.id) || [];

        fnd.tag = tagIds
            .map(id => tagById.get(id))
            .filter(Boolean)
            .sort((a, b) => a.name.localeCompare(b.name))
        ;
    }

    return data ?? [];
};

export const searchProperties = async(config = {filter: {}}) => {
        let propertiesPromise = fetchFindingsProperties(config)
            .catch((e) => {
                return [];
            })
            .then(pProperties => {
                return pProperties;
            })
        return propertiesPromise;
    }

export const searchFindingPropertiesCount = async(config = {filter: {}}) => {
    let propertiesPromise = fetchFindingsPropertiesCount(config)
        .catch((e) => {
            return [];
        })
        .then(pProperties => {
            return pProperties;
        })
    return propertiesPromise;
}

export const searchFindingPropertiesCountByKind = async(config = {filter: {}}) => {
    let propertiesPromise = fetchFindingsPropertiesCountByKind(config)
        .catch((e) => {
            return [];
        })
        .then(pProperties => {
            return pProperties;
        })
    return propertiesPromise;
}


export const handleOwnerChange = async (selected_rows, value) => {
    if (selected_rows.length < 1) return notificate("select_element", "modal");
    let reqData = [];
    for (let row of selected_rows) {
        reqData.push({
            user_id           : value === "null" ? null : value,
            asset_id          : row.asset_id,
            vulnerability_id  : row.vulnerability_id,
            id                : row.id,
        });
    }
    await handleFindingsUpsert(reqData)
}

export const handleStatusChange = async (selected_rows, value) => {
    if (selected_rows.length < 1) return notificate("select_element", "modal");
    let reqData = [];
    for (let row of selected_rows) {
        reqData.push({
            status            : value,
            asset_id          : row.asset_id,
            vulnerability_id  : row.vulnerability_id,
            id                : row.id,
        });
    }
    await handleFindingsUpsert(reqData)
}

/* Reset */

//const shouldUpdateFullData = (updatedAt) => updatedAt < new Date(Date.now() - 5 * 60 * 1000);

export const replaceFindings = (newFindings) => {
    if(newFindings){
        findingsData.length = 0;
        findingsData.push(...newFindings);
    }
};

export const replaceFindingsListElements = (newElements) => {
    if(newElements){
        findingsListData.length = 0;
        findingsListData.push(...newElements);
    }
};


// const replaceAllFindingsData = (newFindings) => {
//     allFindingsData.length = 0;
//     allFindingsData.push(...newFindings);
// };


export const resetFindings = () => {
    replaceFindings([]);
    //replaceAllFindingsData([]);
    //findings.allData.updatedAt = null;
    findings.loading = false;
    findings.errors = null;
    findings.findingsListData.loading = false;
    findings.findingsListData.errors = null;
};
